import { FC, useContext, useEffect } from "react";

import { Row, Col, Typography, Dropdown } from "antd";

import { ActionButton } from '@hdi-seguros/web-components.action-button';

import { InfoContext } from "../../../../contexts";
import { QuestionCircleOutlined } from "@ant-design/icons";

import './index.css'

export interface PageHeaderActions {
    label?:     string;
    icon?:      JSX.Element;
    onClick?:   () => void;
    disabled?:  boolean;
}
export interface PageHeaderProps {
    actions?: Array<PageHeaderActions>;
    activeTour?: () => void | undefined;
};

const _renderActions = (actions: Array<PageHeaderActions>) => {
    if(!actions.length) return <></>;

    if(actions.length === 1) {
        const { onClick, label = '', icon } = actions[0];
        return (
            <ActionButton
                onClick={onClick}
                label={label}
                icon={ icon }
                key={`action-button-${label}`}
                type="secondary"
                className='btn-accent-outline-barbuss'
                disabled={!onClick}
            />
        );
    };

    const items = actions.map((props, i) => ({ ...props, key: `${props.label}-${i}`, icon: undefined }));

    return (
        <Dropdown menu={{ items }} trigger={['click']} >
            <ActionButton
                label="Acciones"
                type="secondary"
                className="btn-accent-outline-barbuss"
            />
        </Dropdown>
    )
};

export const PageHeader: FC<PageHeaderProps> = ({ actions = [], activeTour }) =>  {
    const { title } = useContext(InfoContext);

    useEffect(() => {
        document.title = title || 'BARBUSS Productores';
    }, [title]);

    return (
        <Row align='middle' style={{ marginBottom: 15 }}>
            <Col className="page-header__title" span={ actions?.length ? 16 : 24 }>
                <Typography.Title level={ 3 }  style={{ margin: 0, width: 'auto' }} >
                    { title }
                </Typography.Title>
                {
                    activeTour ? (
                        <ActionButton 
                            label=""
                            icon={<QuestionCircleOutlined />}
                            onClick={activeTour}
                            type="secondary"
                            className="page-header__tour-button"
                        />
                    ) : null
                }
            </Col>
            
            <Col span={8}>
                <Row justify='end'>
                    {
                    _renderActions(actions)
                    }
                </Row>
            </Col>
        </Row>
    )
}